import React from 'react';
import { Container } from '../ui/Container';
import { FileText, CheckCircle, Truck, Palette } from 'lucide-react';
export function TrustStrip() {
  const trustItems = [{
    icon: FileText,
    text: 'Quote-first, no fuss',
    color: 'text-cyan-500'
  }, {
    icon: CheckCircle,
    text: 'Clear proofing process',
    color: 'text-magenta-500'
  }, {
    icon: Truck,
    text: 'Australia-wide delivery',
    color: 'text-yellow-500'
  }, {
    icon: Palette,
    text: 'In-house design team',
    color: 'text-purple-500'
  }];
  return <div className="bg-cyan-50/30 border-y border-cyan-100 py-8" data-id="element-381">
      <Container data-id="element-382">
        <div className="flex justify-center items-center" data-id="element-383">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 lg:gap-16 w-full max-w-4xl" data-id="element-384">
            {trustItems.map(item => <div key={item.text} className="flex items-center justify-center group" data-id="element-385">
                <div className={`p-2 rounded-full bg-white shadow-sm mr-3 group-hover:scale-110 transition-transform duration-300 ${item.color}`} data-id="element-386">
                  <item.icon className="h-5 w-5" data-id="element-387" />
                </div>
                <span className="text-gray-700 font-semibold text-sm whitespace-nowrap" data-id="element-388">
                  {item.text}
                </span>
              </div>)}
          </div>
        </div>
      </Container>
    </div>;
}